import {AuthGuard} from './shared/_guards/auth.guard';
import {ErrorComponent} from './components/error/error.component';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ImComponent} from './components/im/im.component';

const routes: Routes = [
  {
    component: ErrorComponent,
    path: 'error',
  },
  {
    path: 'intramonth',
    component: ImComponent,
    canActivate: [AuthGuard]
  },
  // REDIRECTS
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'intramonth',
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'intramonth',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {useHash: true, relativeLinkResolution: 'legacy'})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
